import type {PartSchema} from '../types';

export const hasNestedCompare = (part: PartSchema) => part.compare === 'nested';
